// name of the custom toaster event
export const MAIN_NAV_TOASTER_CREATE_EVENT = 'blkAcDashboardToastCreate';

// after x miliseconds toaster will be closed automatically
export const DEFAULT_TOAST_LIFETIME = 7000;

// the amount of miliseconds we need to wait between two visible states
export const ANIMATION_DELAY = 100;
